import React from 'react'
import image from './../images/Launch Call to Action Section.png'
import Navbar from '../components/Navbar'
import FAQs from '../components/FAQs'
import Footer from '../components/Footer'

const Policy = () => {
    return (
        <main className="main" id="top">
            <Navbar />
            <section className="position-relative vw-100" style={{height: 400}} id="home">
                <div className="position-absolute w-100 h-100" style={{backgroundImage: `url('${image}')`, backgroundPosition: "top", backgroundSize: "cover", backgroundRepeat: "no-repeat",  top: 0, left: 0, zIndex: -1, filter: "brightness(0.35)"}}>
                </div>
            </section>
            <section className="position-relative p-lg-3" id="policy">
                <div className="container">
                    <div className="row mb-4 mt-1">
                        <div className="col-md-12 h-100 text-center text-md-start p-0 p-md-5 pb-3">
                            <h1>HUSTLE CONNECTS – PRIVACY POLICY</h1>
                            <p><strong>Effective Date:</strong> 1st January 2026</p>

                            <p>
                                Hustle Connects (“HC”, “we”, “us”, “our”) values your privacy. This Privacy Policy
                                explains how we collect, use, disclose, and safeguard your information when you
                                use our platform – including our mobile app, website, and related services.
                            </p>

                            <p>
                                By using Hustle Connects, you agree to this Privacy Policy.
                            </p>

                            <h2>1. What personal data do we process?</h2>
                            <p>When signing up or using HC services, you may provide us with:</p>
                            <ul>
                                <li>Full name, phone number, and email address</li>
                                <li>Gender and date of birth</li>
                                <li>Location</li>
                                <li>Service or business category and pricing (for providers)</li>
                                <li>Identification document (for verification purposes)</li>
                                <li>Business incorporation certificate (for verification purposes)</li>
                            </ul>

                            <h3>Personal data we collect about you when you use the HC app</h3>
                            <ul>
                                <li>Device details (type, OS, browser)</li>
                                <li>App usage behaviour, session history, and request/service interactions</li>
                                <li>Crash logs and error reports</li>
                            </ul>

                            <h3>Personal data we collect about you from other sources</h3>
                            <ul>
                                <li>Payment aggregators (for transaction processing)</li>
                            </ul>

                            <h2>2. What purposes do we use your personal data for and what is our legal basis?</h2>

                            <h3>Provision of the Hustle Connects Services</h3>
                            <ul>
                                <li>To match users with the right services or providers</li>
                                <li>To facilitate payments and maintain accurate service records</li>
                                <li>To help users track request history</li>
                            </ul>

                            <h3>Customer Support</h3>
                            <ul>
                                <li>To respond to inquiries and complaints</li>
                                <li>To verify user identity and service activity</li>
                                <li>To ensure quality assurance</li>
                            </ul>

                            <h3>Safety and Security</h3>
                            <ul>
                                <li>To verify users through IDs and usage patterns</li>
                                <li>To detect fraud, abuse, or illegal activity</li>
                                <li>To prevent misuse of the platform and protect users</li>
                            </ul>

                            <h3>Marketing and Advertising</h3>
                            <ul>
                                <li>To send personalized offers, discounts, or campaigns</li>
                                <li>To inform users about product launches or updates</li>
                            </ul>

                            <h3>Service Communications</h3>
                            <ul>
                                <li>To share platform updates, policy changes, or notifications</li>
                                <li>To inform users of scheduled maintenance or disruptions</li>
                            </ul>

                            <h3>Research and Improvement</h3>
                            <ul>
                                <li>To analyze usage behaviour and optimize features</li>
                                <li>To improve app speed, performance, and usability</li>
                                <li>To test and launch new services</li>
                            </ul>

                            <h3>Legal Proceedings and Compliance</h3>
                            <ul>
                                <li>To cooperate with legal requests or investigations</li>
                                <li>To enforce our Terms of Service</li>
                            </ul>

                            <h2>3. Who do we share your personal data with?</h2>
                            <ul>
                                <li>Other users: Limited profile or service-related information</li>
                                <li>Third-party service partners: Payment processors and cloud providers</li>
                                <li>Legal authorities: When required by law</li>
                                <li>Internal teams for audits, development, and service improvement</li>
                            </ul>

                            <h2>4. Does Hustle Connects transfer your personal data to other countries?</h2>
                            <p>
                                While we primarily operate in Ghana, our cloud providers may host data globally.
                                All data is protected using strict confidentiality and encryption standards.
                            </p>

                            <h2>5. How do we keep your personal data safe?</h2>
                            <ul>
                                <li>SSL encryption during data transmission</li>
                                <li>Encrypted cloud-based storage</li>
                                <li>Restricted access controls</li>
                                <li>Regular audits and staff confidentiality training</li>
                            </ul>

                            <h2>6. How long do we retain your personal data?</h2>
                            <p>
                                We retain personal data only as long as necessary to provide our services or meet
                                legal obligations. Data may be archived or anonymized after account deletion.
                            </p>

                            <h2>7. What are your rights?</h2>
                            <ul>
                                <li>Request access to your personal data</li>
                                <li>Correct inaccurate information</li>
                                <li>Request deletion of your data (where legally allowed)</li>
                                <li>Withdraw consent at any time</li>
                                <li>Opt out of marketing communications</li>
                            </ul>

                            <h2>8. Direct marketing</h2>
                            <p>
                                If you opt in, we may send promotions and updates via email, phone, or app
                                notifications. You can unsubscribe at any time.
                            </p>

                            <h2>9. Changes to this Privacy Policy</h2>
                            <p>
                                Updates will be communicated via the app or email. Continued use of Hustle
                                Connects means acceptance of the updated policy.
                            </p>

                            <h2>10. Contact us</h2>
                            <p>
                                <strong>Email:</strong> support@hustleconnects.com<br />
                                <strong>Phone:</strong> +233 (25) 612 1731
                            </p>

                            <p>
                                By using Hustle Connects, you consent to the collection and use of information as
                                outlined in this Privacy Policy.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    )
}

export default Policy;

